import { Fragment } from 'react'

import { TOTAL_SECTIONS } from '~/pages/anatomyV2/libs/components/SectionProgress/constants'
import {
  SectionProgressStyles as S,
  TCircleState,
} from '~/pages/anatomyV2/libs/components/SectionProgress/styles'
import { SECTION_PAGE_IDS } from '~/pages/anatomyV2/libs/sectionPages'
import { PageId } from '~/shared/constants/pagesConstants'

interface ISectionProgressProps {
  currentSection: number
  pageId?: PageId
  dimCurrent?: boolean
}

const SECTIONS = Array.from({ length: TOTAL_SECTIONS }, (_, i) => i + 1)

const getCircleState = (
  section: number,
  currentSection: number,
): TCircleState => {
  if (section < currentSection) return 'completed'
  if (section === currentSection) return 'current'
  return 'pending'
}

const getCurrentSectionFillPercent = (
  currentSection: number,
  pageId?: PageId,
): number => {
  if (!pageId) return 0

  const sectionPageIds = SECTION_PAGE_IDS[currentSection]
  if (!sectionPageIds || sectionPageIds.length < 2) return 0

  const pageIndex = sectionPageIds.indexOf(pageId)
  if (pageIndex < 0) return 0

  return (pageIndex / (sectionPageIds.length - 1)) * 100
}

const SectionProgress = ({
  currentSection,
  pageId,
  dimCurrent,
}: ISectionProgressProps) => {
  const fillPercent = getCurrentSectionFillPercent(currentSection, pageId)

  return (
    <>
      <S.Root>
        <S.Circle $state="start" />

        {SECTIONS.map((section) => (
          <Fragment key={section}>
            <S.Line
              $isPast={section < currentSection}
              $fillPercent={
                section === currentSection ? fillPercent : undefined
              }
            />

            <S.Circle
              $state={getCircleState(section, currentSection)}
              $dimCurrent={dimCurrent}
            >
              {section < currentSection && (
                <S.Checkmark viewBox="0 0 12 10" fill="none">
                  <path
                    d="M2 5L4.5 7.5L10 2"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </S.Checkmark>
              )}
            </S.Circle>
          </Fragment>
        ))}
      </S.Root>

      <S.Divider />
    </>
  )
}

export default SectionProgress
